<template>
  <div class="mstablelist global__scrollcustom">
    <div class="row m-0">
      <div class="w-100">
        <div class="button__header">
          <button :class="`${detail.freightMode === 'OCEAN' ? 'button__bluecorporite' : detail.freightMode === 'AIR' ? 'button__purplecorporite' : detail.freightMode === 'LAND' ? 'button__deepgreen' : '' } mr-3`" @click.prevent="uploadfile()">Upload</button>
        </div>
      </div>
    </div>
    <div v-if="isLoading">
      <half-circle-spinner
        :animation-duration="750"
        :size="100"
        color="#1D3354"
        class="mx-auto" />
    </div>
    <div :class="`mstablelist__document ${detail.freightMode === 'OCEAN' ? 'th_bluecorporite' : detail.freightMode === 'AIR' ? 'th_purplecorporite' : detail.freightMode === 'LAND' ? 'th_deepgreen' : '' }`" v-else>
      <b-table
        sticky-header
        no-border-collapse
        responsive
        striped
        :items="items"
        :fields="fields">
        <template v-slot:head()="scope">
          <div class="text-nowrap">
            <span v-if="scope.column === 'download'"></span>
            <span v-else>{{ scope.label.toUpperCase() }}</span>
          </div>
        </template>
        <template v-slot:cell(fileName)="row">
          <div class="text-nowrap">
            <p>{{ row.item.fileName.category }}</p>
            <p>{{ row.item.fileName.desc }}</p>
          </div>
        </template>
        <template v-slot:cell(download)="row">
          <div class="text-nowrap text-center">
            <img :src="row.item.download.image"
                @click.prevent="downloadDoc(row.item.download.shipmentId,
                                            row.item.download.orderNumber,
                                            row.item.download.fileId,
                                            row.item.download.fileCategory,
                                            row.item.download.fileExt)">
          </div>
        </template>
        <template v-slot:table-caption v-if="!items || items.length === 0">
          <i>No Attachment</i>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { HalfCircleSpinner } from 'epic-spinners'
import { mapGetters } from 'vuex'
import mixinDateTime from '@/mixin/getters/date-time'

export default {
  name: 'Document',
  components: {
    HalfCircleSpinner
  },
  mixins: [mixinDateTime],
  data () {
    return {
      shipmentId: this.$route.params.id_shipment,
      orderNumber: this.$route.params.order_number,
      fields: [
        'no.',
        'fileName',
        'dateAndTime',
        'download'
      ],
      items: []
    }
  },
  computed: {
    ...mapGetters({
      detail: 'shipment/item',
      documents: 'shipment/docs',
      isLoading: 'shipment/isLoadingDoc',
      isError: 'shipment/errorDoc'
    }),
    ...mapGetters({
      files: 'file/items',
      isUploading: 'file/isUploading',
      isUploaded: 'file/isUploaded',
      isErrorUploading: 'file/errorUploading'
    })
  },
  mounted () {
    this.fetchShipmentDocument()
  },
  methods: {
    uploadfile: function () {
      this.$eventHub.$emit('dialog-mgshipement-upload', {id: this.shipmentId, referenceNumber: this.orderNumber.split('-').join('/'), type: 'SHIPMENT'})
    },
    async fetchShipmentDocument () {
      const shipmentId = this.shipmentId
      const orderNumber = this.orderNumber
      await this.$store.dispatch('shipment/FETCH_SHIPMENT_DOCUMENT', {shipmentId, orderNumber})
      await this.getItems()
    },
    getItems () {
      return new Promise((resolve) => {
        this.items = []
        if (this.documents) {
          this.documents.forEach((item, index) => {
            const newItem = {
              no: `${index + 1}.`,
              fileName: { category: item.fileCategory, desc: item.fileDesc },
              dateAndTime: `${this.getDateDefauld(item.createdAt)} ${this.getTimeFormat1(item.createdAt)}`,
              download: {
                image: require('@/assets/image/icon/download-blue-medium.svg'),
                shipmentId: item.shipmentId,
                orderNumber: item.orderNumber,
                fileId: item.fileId,
                fileCategory: item.fileCategory,
                fileExt: item.fileExt
              }
            }
            this.items.push(newItem)
          })
        }
        return resolve()
      })
    },
    downloadDoc (shipmentId, orderNumber, fileId, fileCategory, fileExt) {
      const type = 'shipment'
      const fileName = `${fileCategory}${fileExt}`
      const splittedOrderNumber = orderNumber.split('/').join('-')
      this.$store.dispatch('shipment/DOWNLOAD_SHIPMENT_DOCUMENT', {shipmentId, orderNumber: splittedOrderNumber, type, fileName, fileCategory, fileId})
    }
  },
  watch: {
    isUploaded (data, oldData) {
      if (data) {
        this.fetchShipmentDocument()
      }
    }
  },
  sockets: {
    connect: function () {
      console.log('socket connected')
    },
    action: function (data) {
      if (data.type === 'RECEIVE_WEBSOCKET_UPDATE_SHIPMENT_DOCUMENTS') {
        this.fetchShipmentDocument()
        this.messages.push(data.payload.response.message)
        this.$eventHub.$emit('dialog-mgshipement-upload-hide')
      }
      console.log('this method was fired by the socket server. eg: io.emit("action", data)')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/managementShipment/detail/Documents.vue